/**
 * Created by alvinoktavianus on 6/21/17.
 */

export const BILLING_REDIRECT_UPDATE_PAYMENT_STATUS =
  'BILLING_REDIRECT_UPDATE_PAYMENT_STATUS';
export const BILLING_REDIRECT_SET_NOTIFICATION_MESSAGE =
  'BILLING_REDIRECT_SET_NOTIFICATION_MESSAGE';
export const BILLING_REDIRECT_SET_NOTIFICATION_TYPE =
  'BILLING_REDIRECT_SET_NOTIFICATION_TYPE';
